import { Children } from "react";
import { createPortal } from "react-dom";
const popupRootId = "modal-root";
const getPopupRoot = () => {
  let popupRoot = document.getElementById(popupRootId);
  if (!popupRoot) {
    popupRoot = document.createElement("div");
    popupRoot.id = popupRootId;
    popupRoot.role = "complementary";
    document.body.append(popupRoot);
  }
  return popupRoot;
};
const PopupPortal = (props) => {
  const { children } = props;
  const child = Children.only(children);
  return createPortal(child, getPopupRoot());
};
export {
  PopupPortal,
  getPopupRoot,
  popupRootId
};
